export const environment = {
  production: false,
  apiUrl: 'https://kinsphere360.vizipp.com',
  apiBase: '/api/v1',
};
